'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMerchants = undefined;

var _serviceHelpers = require('./serviceHelpers');

var _lodash = require('lodash.filter');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMerchants = exports.getMerchants = function getMerchants(accessToken, env) {
  return (0, _serviceHelpers.callFetch)('merchantConfigUrl', 'GET', 'v0/merchants?merchantIdFilter', null, accessToken, env).then(function (response) {
    return response.map(function (merchant) {
      return { name: merchant.displayName || merchant.merchantId, id: merchant.merchantId };
    });
  });
};
//# sourceMappingURL=merchantConfig.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress-technology/react-platform-tenant-selector/lib/services/merchantConfig.js
// module id = 568
// module chunks = 0